import React from "react";

import {
  ButtonGroupContainer,
  GroupInput,
  GroupButton,
  GroupButtonContainer,
} from "./styles";
import { useTranslation } from "react-i18next";

const number_regex = /^[0-9]*$/;

const ButtonGroup = ({
  items = [],
  value,
  onClick = () => {},
  onChange = () => {},
  returnWholeItem = false,
  options: { input = false } = {},
}) => {
  const { t } = useTranslation();

  return (
    <ButtonGroupContainer>
      <GroupButtonContainer numberOfItems={items.length}>
        {items.map((item) => (
          <GroupButton
            key={crypto.randomUUID()}
            onClick={() => onClick(returnWholeItem ? item : item.value)}
            isSelected={item.value === value}
          >
            {item.i18n ? t(item.i18n) : item.label || item.icon()}
          </GroupButton>
        ))}
      </GroupButtonContainer>
      {input && (
        <GroupInput
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={(e) => {
            if (number_regex.test(e.target.value)) {
              onChange(e);
            }
          }}
        />
      )}
    </ButtonGroupContainer>
  );
};

export default ButtonGroup;
